import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import {
    NavLink, withRouter
} from "react-router-dom";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import './styles.scss';
import functionCommon from "../../core/common/function";

let ifStaff = true;
let ifStaffManager = false;
let ifDirector = false;
let ifStaffSupervisor = false;
let ifStaffTeamleader = false;
let ifHr = false;

class MainNavigation extends Component {

    constructor(){
        super();
        this.state = {
            disableLink: false
        }
    }

    componentWillMount() {
        if (functionCommon.getRole() === 'staff') {
            ifStaff = false;
        }
        if (functionCommon.getRole() === 'staff' && (functionCommon.getLevel() === 'manager' || functionCommon.getLevel() === 'director')) {
            ifStaffManager = true;
        }
        if (functionCommon.getRole() === 'staff' && functionCommon.getLevel() === 'teamLeader') {
            ifStaffTeamleader = true;
        }
        if (functionCommon.getRole() === 'director') {
            ifStaff = false;
            ifDirector = true;
        }
        if (functionCommon.getRole() === 'staff' && functionCommon.getLevel() === 'supervisor') {
            ifStaffSupervisor = true;
        }
        if (functionCommon.getRole() === 'hr') {
            ifStaff = false;
            ifHr = true;
        }
    }

    componentDidMount() {
        this.setState({
            disableLink: false
        });
    }

    navListExpand = (e) => {
        e.currentTarget.parentElement.classList.toggle('active')
    }

    handleNavLink = (e) => {
        if (e.currentTarget.classList.contains("active") 
            && (this.props.location.pathname === e.currentTarget.attributes.href.nodeValue)) {
            this.setState({
                disableLink: true
            });
            setTimeout(function(){
                window.location.reload();
            }, 500);
        }
    }

    render() {
        const { t } = this.props;
        if (ifHr) {
            return (
                <nav>
                    <ul>
                        <li className="has-children">
                            <NavLink to="/employee" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/employee')}>
                                {t('navigation.master')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/employee" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/employee')}>
                                        {t('navigation.employee')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/project" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/project')}>
                                        {t('navigation.project')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/om-project-management" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/om-project-management')}>
                                        {t('navigation.omProjectManagement')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li className="has-children" >
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/total-record" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/total-record')}>
                                        {t('navigation.totalRecord')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink exact to="/approve" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/approve')}>
                                {t('navigation.approve')}
                            </NavLink>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/all-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/all-leave-request')}>
                                        {t('labels.allLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/leave-overview" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/leave-overview')}>
                                        {t('labels.leaveOverview')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/config" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/config')}>
                                        {t('labels.config')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        } else if (ifStaff) {
            return (
                <nav>
                    <ul>
                        <li className="has-children">
                            <NavLink to="/employee" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/employee')}>
                                {t('navigation.master')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/employee" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/employee')}>
                                        {t('navigation.employee')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/project" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/project')}>
                                        {t('navigation.project')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/om-project-management" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/om-project-management')}>
                                        {t('navigation.omProjectManagement')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li className="has-children" >
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/total-record" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/total-record')}>
                                        {t('navigation.totalRecord')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink exact to="/approve" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/approve')}>
                                {t('navigation.approve')}
                            </NavLink>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/all-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/all-leave-request')}>
                                        {t('labels.allLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/leave-overview" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/leave-overview')}>
                                        {t('labels.leaveOverview')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        } else if (ifStaffManager) {
            return (
                <nav>
                    <ul>
                        <li className="has-children">
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/total-record" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/total-record')}>
                                        {t('navigation.totalRecord')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink exact to="/approve" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/approve')}>
                                {t('navigation.approve')}
                            </NavLink>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/all-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/all-leave-request')}>
                                        {t('labels.allLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/leave-overview" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/leave-overview')}>
                                        {t('labels.leaveOverview')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        } else if (ifStaffTeamleader) {
            return (
                <nav>
                    <ul>
                        <li className="has-children">
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink exact to="/approve" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/approve')}>
                                {t('navigation.approve')}
                            </NavLink>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/all-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/all-leave-request')}>
                                        {t('labels.allLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/leave-overview" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/leave-overview')}>
                                        {t('labels.leaveOverview')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        } else if (ifDirector) {
            return (
                <nav>
                    <ul>
                        <li className="has-children" >
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/total-record" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/total-record')}>
                                        {t('navigation.totalRecord')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink exact to="/approve" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/approve')}>
                                {t('navigation.approve')}
                            </NavLink>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/all-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/all-leave-request')}>
                                        {t('labels.allLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/leave-overview" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/leave-overview')}>
                                        {t('labels.leaveOverview')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        } else if (ifStaffSupervisor) {
            return (
                <nav>
                    <ul>
                        <li className="has-children" >
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/total-record" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/total-record')}>
                                        {t('navigation.totalRecord')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink exact to="/approve" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/approve')}>
                                {t('navigation.approve')}
                            </NavLink>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/all-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/all-leave-request')}>
                                        {t('labels.allLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/leave-overview" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/leave-overview')}>
                                        {t('labels.leaveOverview')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        } else {
            return (
                <nav>
                    <ul>
                        <li className="has-children">
                            <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/update-working-hour')}>
                                {t('navigation.engineerHourRecord')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/update-working-hour" className={(this.state.disableLink) ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/update-working-hour')}>
                                        {t('navigation.updateWorkingHour')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li className="has-children">
                            <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                onClick={this.handleNavLink.bind('/my-leave-request')}>
                                {t('labels.leaveManagemnet')}
                            </NavLink>
                            <Icon name='caret down' onClick={this.navListExpand}></Icon>
                            <ul>
                                <li>
                                    <NavLink exact to="/my-leave-request" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/my-leave-request')}>
                                        {t('labels.myLeaveRequest')}
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/holiday" className={this.state.disableLink ? "disable-link" : ""}
                                        onClick={this.handleNavLink.bind('/holiday')}>
                                        {t('labels.holiday')}
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            )
        }
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withRouter,
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(MainNavigation);
